module.exports = __webpack_public_path__ + "static/media/gamomat.621daeb3.jpeg";